import {Enum} from 'enumify';

export default class CurrencyType extends Enum {}

CurrencyType.initEnum({
  USD: {
    currencyString: '$',
    decimalScale: 2,
  },
  KRW: {
    currencyString: '₩',
    decimalScale: 0,
  },
});



// WEBPACK FOOTER //
// ./src/constants/CurrencyType.js